import { render, staticRenderFns } from "./QDFM_Detail.vue?vue&type=template&id=09059838&scoped=true&"
import script from "./QDFM_Detail.vue?vue&type=script&lang=js&"
export * from "./QDFM_Detail.vue?vue&type=script&lang=js&"
import style0 from "./QDFM_Detail.vue?vue&type=style&index=0&id=09059838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09059838",
  null
  
)

export default component.exports